import { render, staticRenderFns } from "./zj.vue?vue&type=template&id=16540410&scoped=true"
import script from "./zj.vue?vue&type=script&lang=js"
export * from "./zj.vue?vue&type=script&lang=js"
import style0 from "./zj.vue?vue&type=style&index=0&id=16540410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16540410",
  null
  
)

export default component.exports